export default {"src":"/_next/static/media/twitter.dd06e897.svg","height":32,"width":32};